// @flow

import React from 'react';
import {
  Container,
  // Table,
  // Button,
  Col,
  Row,
} from 'reactstrap';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { updateCart, getCartData } from '../../../redux/cart';
import { fetchInvoice } from '../../../services/cart';
import { appendHoneyGuide } from '../../../lib/utils';
import {  Order } from '../Common';
import {
  Page,
  Loading,
  WhitePanel,
  PaymentSuccess,
  Prices,
  GuideCard,
  CardsSlider
} from '../../../components';
import { useSelector } from '../../../redux/reduxDB';
import { getCustomToast } from '../../../components/ErrorMessage';

const title = appendHoneyGuide('Payment Success');

function CartSuccess(props: RouteComponentProps) {
  const { match } = props;
  const { invoiceId } = match.params;
  const [invoice, orderIds] = useSelector(getCartData);

  React.useEffect(
    () => {
      if (!invoice) {
        fetchInvoice(invoiceId)
          .then(updateCart)
          .catch(() => { 
            getCustomToast('There seems to be a problem. Please refresh the page', 'error');
          });
      }
    },
    [invoiceId, invoice]
  );

  if (!invoice || !orderIds) return <Loading />;
  if (invoice.status.toLowerCase() === 'pending') return null;

  const { discount, rate, amount, currency } = invoice;

  return (
    <Page title={title}>
      <Container>
        <Row>
          <Col lg="6">
            <PaymentSuccess className="form-cart" />
            <CardsSlider
              title="Featured Guides"
              endpoint="users/leaders?is_featured=1"
              Card={GuideCard}
              showNoOfCards={3}
            />
          </Col>
          <Col lg="6" className="trek-summary">
            <WhitePanel>
              <h2>Cart Summary</h2>
              {orderIds.map(orderId => (
                <Order orderId={orderId} key={orderId} />
              ))}
              <Prices
                discount={discount}
                basePrice={rate}
                grandTotal={amount}
                currency={currency}
              />
            </WhitePanel>
          </Col>
        </Row>
      </Container>
    </Page>
  );
}

export default withRouter(CartSuccess);



// WEBPACK FOOTER //
// ./src/screens/Cart/Success/CartSuccess.js